var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report', [_c('v-container', {
    staticClass: "padded"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "display-1 text--primary"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]), _c('v-card-actions', [_c('v-row', {
    staticClass: "justify-center align-center pb-6"
  }, [_c('v-btn', {
    attrs: {
      "elevation": "2"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('ReportHome');
      }
    }
  }, [_vm._v("Neue Schadensmeldung")])], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pt-4",
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-row', {
    staticClass: "justify-center align-center pb-6"
  }, [_c('img', {
    staticClass: "contain",
    staticStyle: {
      "max-height": "175px"
    },
    attrs: {
      "src": require("@/assets/partner_contact_success.svg")
    }
  })])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }